import { NgModule }      from '@angular/core';
import { CommonModule }  from '@angular/common';
import { FormsModule} from '@angular/forms';
import { Routes, RouterModule }  from '@angular/router';
import {    BlogUserdetails } from './bloguserdetails.page';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


export const routes: Routes = [
    { path: 'bloguserdetails', component: BlogUserdetails },
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes),
        NgbModule
    ],
    declarations: [
        BlogUserdetails
    ],
   
   
})

export class BlogUserdetailsModule { }



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/bloguserdetails/bloguserdetails.module.ts